import React from "react"
import { CustomDialog } from "../../../../../ui/molecules/Dialog/CustomDialog"
import FilterCategoriesPanel from "../FilterCategoriesPanel"
import { CheckboxFilterOption, FilterCategory } from "../types"

interface Props {
  filters: FilterCategory[]
  onFiltersUpdate: (filters: FilterCategory[]) => void
  open: boolean
  onClose: () => void
  onConfirm: (filters: FilterCategory[]) => void
}

const getSelectedParent = (selectedPath: CheckboxFilterOption[]) =>
  selectedPath.length > 0 ? selectedPath[selectedPath.length - 1] : undefined

const shouldSkipFirstLevel = (category: FilterCategory) => {
  const options = category.options as CheckboxFilterOption[]
  if (options.length === 1 && (options[0].children?.length ?? 0) > 0) {
    return true
  }

  return false
}

const FiltersModal = ({
  open,
  onClose,
  onConfirm,
  filters,
  onFiltersUpdate,
}: Props) => {
  const handleClear = () => {}

  const [selectedCategory, setSelectedCategory] = React.useState<
    FilterCategory | undefined
  >()
  const [selectedPath, setSelectedPath] = React.useState<
    CheckboxFilterOption[]
  >([])

  const handleCancel = () => {
    if (!selectedCategory) {
      onClose()
    } else {
      setSelectedCategory(undefined)
    }
  }

  const handleSelectCategory = (category: FilterCategory) => {
    setSelectedCategory(category)

    // skip first level if it has only one node
    if (category.type === "checkbox" && shouldSkipFirstLevel(category)) {
      const options = category.options as CheckboxFilterOption[]
      setSelectedPath([options[0]])
    }
  }

  const handleUpdatePath = (options: CheckboxFilterOption[]) => {
    // skip first level if it has only one node
    if (
      selectedCategory &&
      options.length === 0 &&
      shouldSkipFirstLevel(selectedCategory)
    ) {
      setSelectedPath([])
      setSelectedCategory(undefined)
    } else {
      setSelectedPath(options)
    }
  }

  return (
    <CustomDialog
      open={open}
      onClose={onClose}
      fullScreenAll
      openDirection="right"
      noGutters
    >
      <FilterCategoriesPanel
        categories={filters}
        selectedCategory={selectedCategory}
        selectedParent={getSelectedParent(selectedPath)}
        title="Filtra per"
        onCancel={handleCancel}
        onClear={handleClear}
        onConfirm={() => onConfirm(filters)}
        onCategorySelected={handleSelectCategory}
        onFiltersUpdate={onFiltersUpdate}
        onOptionExpand={(option) => handleUpdatePath([...selectedPath, option])}
        onOptionBack={() =>
          handleUpdatePath(selectedPath.slice(0, selectedPath.length - 1))
        }
      />
    </CustomDialog>
  )
}

export default FiltersModal
